/*------------------------------------*\
	#COOKIE BANNER
\*------------------------------------*/

const initCookieBanner = () => {

	const button = document.querySelector(".js-trigger-cookie-banner");

	if (button) {
		button.addEventListener('click', function (event) {
			UC_UI.showSecondLayer();
		});
	}

}

window.addEventListener('DOMContentLoaded', (event) => {
	initCookieBanner();
});
